// Default placeholder image - Unsplash stock/crypto market themed image
// Using red and blue light streaks image perfect for financial content
// Source: https://unsplash.com/photos/red-and-blue-light-streaks-fiXLQXAhCfk
const DEFAULT_PLACEHOLDER_IMAGE =
  'https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1074&q=80';

/**
 * Get a safe image source with fallback for missing or invalid URLs
 * @param thumbnailUrl - The original thumbnail URL
 * @returns A valid image URL or the default placeholder
 */
export function getImageSrc(thumbnailUrl: string | null | undefined): string {
  // If thumbnail_url is empty, null, or undefined, use fallback
  if (!thumbnailUrl || thumbnailUrl.trim() === '') {
    return DEFAULT_PLACEHOLDER_IMAGE;
  }
  return thumbnailUrl;
}

/**
 * Get the default placeholder image
 * @returns The default placeholder image URL
 */
export function getDefaultPlaceholderImage(): string {
  return DEFAULT_PLACEHOLDER_IMAGE;
}
